exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#notice-list{font-size:18px}#notice-list .issue-date{margin-right:10px}#notice-list .notice-title-block{margin-left:10px}.pager .arrows span{opacity:.1;width:40px;padding:5px 0;background-color:#042304;display:inline-block;margin-right:5px;text-align:center}.pager .arrows span img{max-width:100%;height:auto;vertical-align:middle}.pager .arrows a{width:40px;padding:5px 0;background-color:#da7fa9;display:inline-block;margin-right:5px;text-align:center;-webkit-transition:all .5s;transition:all .5s}.locked{cursor:pointer}#modalPopover .modal{z-index:30000!important}#modalPopover .modal-header{border-bottom:0}#modalPopover .modal-header button{position:absolute;right:10px;top:10px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-44b18eec","scoped":false,"hasInlineConfig":true}!./node_modules/sass-loader/dist/cjs.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./resources/assets/js/mlang/notice/noticeList.vue
// module id = qw5r
// module chunks = 0